export default __webpack_public_path__ + "static/media/live-casino-rebate-ico.d4cc1c3a.svg";